// extracted by mini-css-extract-plugin
export var container = "styles-module__container___JWiZ8";
export var couponBoxContainer = "styles-module__couponBoxContainer____pttf";
export var couponCard = "styles-module__couponCard___SdUi8";
export var expireBtn = "styles-module__expireBtn___sRv4m";
export var inputEditContainer = "styles-module__inputEditContainer___N8G9Y";
export var msgDisplay = "styles-module__msgDisplay___Ob4SQ";
export var searchBox = "styles-module__searchBox___VlVrv";
export var searchButtons = "styles-module__searchButtons___kmtIT";